import { createTheme } from "@mui/material/styles";

const Theme = createTheme({
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: "Lato",
        },
      },
    },
    // Name of the component
    MuiTablePagination: {
      styleOverrides: {
        // Name of the slot
        select: {
          // Some CSS
          borderRadius: "4px",
          border: "1px solid #9E9E9E",
        },
        selectIcon: {
          color: "#616161",
        },
        displayedRows: {
          color: "#424242",
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: "Lato",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontFamily: "Lato",
          padding: "0 12px 0 0",
          height: "40px",
          // background: "white",
          borderRadius: "8px",
        },
      },
    },
  },
});

export default Theme;
